<div class="main-logout-container">
    <h2 class="canceldel-header">Cancel Deletion</h2>
    <mat-divider></mat-divider>
    <p class="logout-title">{{data.msg}}</p>
    <div class="logout-button-div">
        <button class="logout-cancel-button" mat-flat-button color="accent" (click)="close()">No</button>
        <button class="logout-button" mat-flat-button color="primary" (click)="cancelDeleteSubscription()">Yes</button>
    </div>
</div>